<template>
  <col4>
    <v-card class="elevation-4">
      <v-card-title>
        {{ $t('projects.import_dataset_title') }}
      </v-card-title>
      <v-card-subtitle style="min-height: 60px;">
        {{ $t('projects.import_dataset_subtitle') }}
      </v-card-subtitle>
      <v-card-text>
        <v-file-input
          v-model="file"
          accept=".zip"
          :label="$t('projects.import_dataset_file_label')"
          :disabled="uploading"
        ></v-file-input>
        <v-text-field
          v-model="project_name"
          :label="$t('projects.import_dataset_name_label')"
          :disabled="uploading"
        ></v-text-field>
        <v-progress-linear
          v-if="uploading"
          :model-value="progress"
          height="20"
          rounded
          color="primary"
        >
          <strong>{{ progress }}%</strong>
        </v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="uploading"
          :disabled="!can_import"
          @click="importDataset"
        >
          {{ $t('projects.import_dataset_button') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </col4>
</template>

<script>
import Col4 from "@/components/layout/Col4";
import LoadProjectsMixin from "@/mixins/LoadProjectsMixin";

export default {
  name: "ImportCropDatasetCard",
  components: { Col4 },
  mixins: [LoadProjectsMixin],
  data() {
    return {
      file: null,
      project_name: "",
      uploading: false,
      progress: 0,
    };
  },
  computed: {
    selected_file() {
      if (Array.isArray(this.file)) {
        return this.file[0] || null;
      }
      return this.file || null;
    },
    can_import() {
      return this.selected_file && this.project_name.trim() !== "" && !this.uploading;
    },
  },
  methods: {
    showImportError(response) {
      const payload = response && response.data ? response.data : response;
      const errorCode = payload && payload.error_code;
      if (errorCode) {
        const key = `projects.import_dataset_error_${errorCode}`;
        if (this.$te(key)) {
          this.$store.dispatch("snackbars/add_failed_snack", this.$t(key));
          return;
        }
      }
      const message = (payload && payload.error) || this.$t("projects.import_dataset_failed");
      this.$store.dispatch("snackbars/add_failed_snack", message);
    },
    async importDataset() {
      const file = this.selected_file;
      if (!file) {
        return;
      }
      this.uploading = true;
      this.progress = 0;
      try {
        const response = await this.$api.project.importCropDataset(
          file,
          { project_name: this.project_name.trim() },
          (pct) => {
            this.progress = pct;
          },
        );
        if (!response) {
          this.showImportError(null);
          return;
        }
        if (response.error || (response.data && response.data.error)) {
          this.showImportError(response);
          return;
        }
        if (response.limit_reached) {
          this.$store.dispatch(
            "snackbars/add_failed_snack",
            this.$t("import_data.limit_reached", { LIMIT: "?" }),
          );
          return;
        }
        const projectId = response.project_id || (response.data && response.data.project_id);
        const uploaded = response.uploaded ?? (response.data && response.data.uploaded);
        this.$store.dispatch(
          "snackbars/add_success_snack",
          this.$t("projects.import_dataset_success", { count: uploaded || 0 }),
        );
        await this.$store.dispatch("project/load");
        this.file = null;
        this.project_name = "";
        if (projectId) {
          this.$store.commit("user/set_current_project_id", projectId);
          await this.$router.push({ name: "ProjectOverview" });
        }
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
